import axios from 'axios';
import {SUBSITE} from '../store/defaults'

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

const session = axios.create({
  baseURL: SUBSITE + 'PgmToolsRest/v2',
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  withCredentials: true,
  Accept: "application/json; indent=4"
});

export default session

